import { api, unwrap } from '@saas-kit/lib';

export type SettingValue = string | number | boolean | null;

export interface AdminSetting {
  key: string;
  value: SettingValue;
  updated_by_user_id: string | null;
  updated_at: string;
}

interface SettingList {
  items: AdminSetting[];
}

export async function listSettings(): Promise<AdminSetting[]> {
  const data = await unwrap<SettingList>(api.get('/admin/settings'));
  return data.items;
}

export async function updateSetting(
  key: string,
  value: SettingValue,
): Promise<AdminSetting> {
  return unwrap<AdminSetting>(api.put(`/admin/settings/${encodeURIComponent(key)}`, { value }));
}
